var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.099,
    height: 20.001,
    viewBox: "0 0 17.099 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5176",
    "data-name": "Rectangle 5176",
    width: 17.099,
    height: 20.001,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8951",
    "data-name": "Path 8951",
    d: "M15,17.519a2.4,2.4,0,0,1-.232,1.031,2.458,2.458,0,0,1-1.846,1.412,2.638,2.638,0,0,1-.482.036Q7.76,20,3.086,20A3.118,3.118,0,0,1,.065,17.51,3.483,3.483,0,0,1,0,16.862Q0,10,0,3.137A3.11,3.11,0,0,1,2.558.052,2.965,2.965,0,0,1,3.095,0q3.25,0,6.5,0A3.024,3.024,0,0,1,11.78.9q1.164,1.148,2.312,2.312a3.057,3.057,0,0,1,.9,2.187c.007.662,0,1.324,0,1.986v.1c-.036,0-.062.005-.088.005-.355,0-.711,0-1.066,0-.078,0-.093-.027-.093-.1,0-.35,0-.7,0-1.05,0-.032,0-.063,0-.1h-.109q-1.506,0-3.011,0a1.858,1.858,0,0,1-1.813-1.4,1.977,1.977,0,0,1-.058-.478c-.005-1.007,0-2.013,0-3.02,0-.105,0-.105-.106-.105q-2.749,0-5.5,0a1.882,1.882,0,0,0-1.889,1.61,2.244,2.244,0,0,0-.018.346q0,5.187,0,10.375c0,1.114-.006,2.228,0,3.342a1.863,1.863,0,0,0,1.586,1.815,2,2,0,0,0,.3.023q4.675,0,9.35,0a1.259,1.259,0,0,0,1.263-1.191c0-.038.008-.06.054-.06l1.171,0s.01,0,.024.01m-5-16.227v.746q0,1.158,0,2.316A.63.63,0,0,0,10.639,5H13.7c-.008-.039-.013-.065-.02-.091a1.868,1.868,0,0,0-.489-.84Q12.058,2.937,10.921,1.8a2.344,2.344,0,0,0-.353-.279,1.57,1.57,0,0,0-.576-.232",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5171",
    "data-name": "Rectangle 5171",
    width: 1.356,
    height: 5.523,
    transform: "translate(13.66 9.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5172",
    "data-name": "Rectangle 5172",
    width: 5.523,
    height: 1.356,
    transform: "translate(11.576 11.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5173",
    "data-name": "Rectangle 5173",
    width: 5.523,
    height: 1.356,
    transform: "translate(2.953 7.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5174",
    "data-name": "Rectangle 5174",
    width: 5.523,
    height: 1.356,
    transform: "translate(2.953 9.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5175",
    "data-name": "Rectangle 5175",
    width: 5.523,
    height: 1.356,
    transform: "translate(2.953 11.962)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.1da9a16d59fbbeeff70ce48d3e907793.svg";
export { ForwardRef as ReactComponent };